
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/convert-file-formats",
      function () {
        return require("private-next-pages/features/convert-file-formats.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/convert-file-formats"])
      });
    }
  